import BackToTopButton from './BackToTopButton';

export default BackToTopButton;
